import httpService from "./httpService";

export default {
  findByHcReferenceId(hcReferenceId) {
    let params = {hcReferenceId: hcReferenceId};
    return httpService.get("/hcCaseMasterUser/findByHcReferenceId", {
      params: params
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/hcCaseMasterUserService.js